import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import styles from './styles.module.scss'
import Pill from 'srcReact/components/common2/Pill'
import CounterCard from './components/CounterCard'
import MemberCard from './components/MemberCard'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import Spinner from 'srcReact/components/common2/Spinner'
import { getDateFormat3 } from 'srcReact/helpers/datetimeHelper'
import ReadMore from 'srcReact/components/common2/ReadMore'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'

const Info = ({ groupId }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    groupHome: { info, group }
  } = useSelector((state) => state)

  const showUserModal = (user, index, type) => {
    const lp = new LightProfileProto()
    lp.userId = user.id
    if (type === 'staff') {
      lp.userIndex = index
      lp.users = info && info.staff_members && info.staff_members.users
    }
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  useEffect(() => {
    if (groupId) {
      dispatch(groupHomeActions.getGroupHomeInfo(groupId))
    }
  }, [])

  const getTextLength = (html) => {
    const element = document.createElement('div')
    element.innerHTML = html
    return element.textContent.length
  }

  const limit = (string, length) => {
    return [string].map(getTextLength) > length ? string.substring(0, length) + '...' : string
  }

  if (info.loading) {
    return <Spinner />
  }

  const statsInfo = [
    {
      text: t('groupHome.info.stats.members'),
      image: 'groups',
      count: group.members_number
        ? typeof group.members_number === 'object'
          ? group.members_number.active
          : typeof group.members_number === 'number'
          ? group.members_number
          : 0
        : 0
    },
    { text: t('groupHome.info.stats.pastMixrs'), image: 'calendar', count: info.stats.mixrs.finished },
    { text: t('groupHome.info.stats.upcomingMixrs'), image: 'calendar', count: info.stats.mixrs.planned },
    { text: t('groupHome.info.stats.picture'), image: 'picture', count: info.stats.featured_files.pictures },
    { text: t('groupHome.info.stats.documents'), image: 'paperclip', count: info.stats.featured_files.documents },
    { text: t('groupHome.info.stats.links'), image: 'link', count: 0 }
  ]

  return (
    <div className={styles.infoWrapper}>
      <div className={styles.about}>
        <h2>{t('global.aboutGroupMixr', { type: t('global.group') })}</h2>
        <ReadMore>{group.description}</ReadMore>
      </div>

      <div className={styles.interests}>
        <h2>
          {group.group_type === 'expertise'
            ? t('formlabel.expertise', { count: 0 })
            : t('formlabel.interest', { count: 0 })}
        </h2>
        <div className={styles.pill}>
          {group.interests?.length > 0 &&
            group.interests.map((i, idx) => (
              <Pill
                selected={true}
                shared={i.is_common_with_logged_user === 1}
                askForAddToProfile={i.is_common_with_logged_user === 0}
                text={i.name}
                key={idx}
                dataId={i.id}
              />
            ))}
          {group.expertises?.length > 0 &&
            group.expertises.map((i, idx) => (
              <Pill
                type='expertise'
                shared={i.is_common_with_logged_user === 1}
                selected={true}
                text={i.name}
                key={idx}
              />
            ))}
        </div>
      </div>

      <div className={styles.counter}>
        {statsInfo.map((c, i) => (
          <CounterCard key={i} count={c.count} text={c.text} image={c.image} />
        ))}
      </div>

      <div className={styles.team}>
        <div className={styles.leadership}>
          <h2>{t('groupHome.info.leadership')}</h2>
          <div className={styles.members}>
            {info.staff_members.users &&
              info.staff_members.users.length >= 1 &&
              info.staff_members.users.map((m, index) => (
                <MemberCard
                  id={m.id}
                  key={m.id}
                  showUserModal={() => showUserModal(m, index, 'staff')}
                  name={m.firstname + ' ' + m.lastname}
                  picture={m.profile_picture}
                  role={m.role}
                  mimeType={m.mime_type}
                  originalTag={m.original_tag}
                  isOriginal={m.is_original}
                />
              ))}
          </div>
        </div>
        {info.staff_members.users && info.staff_members.users.length >= 2 && (
          <div className={styles.created}>
            <h2>{t('groupHome.info.created')}</h2>
            <MemberCard
              id={group.organizer.user_id}
              showUserModal={() => {
                const organizerUser = info.staff_members.users.find((u) => u.id === group.organizer.user_id)
                showUserModal(organizerUser, 0, 'organizer')
              }}
              name={group.organizer.display_name}
              picture={group.organizer.picture_url}
              createdAt={`on ${dayjs(group.gmt_creation_date).format(getDateFormat3())}`}
              mimeType={group.organizer.mime_type}
              originalTag={group.organizer.original_tag}
              isOriginal={group.organizer.is_original}
              className={styles.createdByMember}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Info
